import { useEffect } from 'react';

import { Pages } from '../../components/Pages/Pages';
import { ApplicationState } from '../../domain/types';
import { useAppDispatch } from '../../hooks';
import useApplicationStateRefresh from '../../hooks/useApplicationStateRefresh';
import { useAuthentication } from '../../hooks/useAuthentication';
import useSettings from '../../hooks/useSettings';
import AccountInfoPageDK from '../../pages/AccountInfoPage/AccountInfoPageDK';
import ConsolidationComplementInfoPageDK from '../../pages/ConsolidationComplementInfoPage/ConsolidationComplementInfoPageDK';
import CoApplicantEmploymentPageDK from '../../pages/EmploymentPage/CoApplicantEmploymentPageDK';
import ErrorPage from '../../pages/ErrorPage/ErrorPage';
import CoApplicantEskatKreditStatusConsentPageDK from '../../pages/EskatKreditStatusPage/CoApplicantEskatKreditStatusConsentPageDK';
import CoApplicantFinancePageDK from '../../pages/FinancePage/CoApplicantFinancePageDK';
import CoApplicantHowToApplyPage from '../../pages/HowToApplyPage/CoApplicantHowToApplyPage';
import CoApplicantKycOngoingPage from '../../pages/KycPage/CoApplicantKycOngoingPage';
import CoApplicantKycPage from '../../pages/KycPage/CoApplicantKycPage';
import KycPage from '../../pages/KycPage/KycPage';
import CoApplicantLivingConditionPage from '../../pages/LivingConditionPage/CoApplicantLivingConditionPage';
import PpiAutoDecline from '../../pages/PpiPage/PpiAutoDecline';
import PpiPageDK from '../../pages/PpiPage/PpiPageDK';
import SelectOfferPage from '../../pages/SelectOfferPage/SelectOfferPage';
import SignAgreementPage from '../../pages/SignAgreementPage/SignAgreementPage';
import OngoingStaticPage from '../../pages/StatusPage/OngoingStaticPage';
import CoApplicantSubmitPageDK from '../../pages/SubmitPage/CoApplicantSubmitPageDK';
import { setCurrentPage } from '../../store/wizard/wizard';

const OngoingApplicationWizardDK = () => {
    const dispatch = useAppDispatch();
    useAuthentication();
    const { showPpiPage } = useSettings();
    const { isError, applicationState } = useApplicationStateRefresh();

    useEffect(() => {
        dispatch(setCurrentPage(0));
    }, [dispatch]);

    if (isError) {
        return <ErrorPage />;
    }

    const getPage = () => {
        switch (applicationState) {
            case 'CO_SUBMIT':
                return (
                    <Pages>
                        <CoApplicantHowToApplyPage />
                        <CoApplicantEskatKreditStatusConsentPageDK />
                        <CoApplicantLivingConditionPage />
                        <CoApplicantEmploymentPageDK />
                        <CoApplicantFinancePageDK />
                        <CoApplicantKycPage />
                        <CoApplicantSubmitPageDK />
                    </Pages>
                );
            case 'ACCEPT_OFFER_MAIN_APPLICANT':
                return (
                    <Pages>
                        <SelectOfferPage />
                    </Pages>
                );
            case 'DISBURSEMENT_ACCOUNT_INFORMATION_MAIN_APPLICANT':
                return (
                    <Pages>
                        <AccountInfoPageDK />
                    </Pages>
                );
            case 'PPI_MAIN_APPLICANT':
                if (!showPpiPage) {
                    return <PpiAutoDecline />;
                }
                return (
                    <Pages>
                        <PpiPageDK />
                    </Pages>
                );
            case 'COMPLEMENT_INFORMATION_CONSOLIDATIONS':
                return (
                    <Pages>
                        <ConsolidationComplementInfoPageDK />
                    </Pages>
                );
            case 'KYC_MAIN_APPLICANT':
                return (
                    <Pages>
                        <KycPage />
                    </Pages>
                );
            case 'KYC_CO_APPLICANT':
                return (
                    <Pages>
                        <CoApplicantKycOngoingPage />
                    </Pages>
                );
            case 'SIGN_AGREEMENT':
                return (
                    <Pages>
                        <SignAgreementPage />
                    </Pages>
                );
            default:
                return <OngoingStaticPage applicationState={applicationState as ApplicationState} />;
        }
    };

    return <>{getPage()}</>;
};

export default OngoingApplicationWizardDK;
